// Grape Variety Filter JavaScript
// Handles the custom grape variety filtering logic for the product list

document.addEventListener('DOMContentLoaded', function() {
  const filterToggle = document.getElementById('filter-toggle');
  const accordionToggles = document.querySelectorAll('.accordion>input[type="checkbox"].hidden')
  filterToggle.addEventListener('change', evt =>{
    accordionToggles.forEach(it => {
      it.removeAttribute('checked');
      it.checked = false;
    })
  })

  const filterForm = document.getElementById('FacetFiltersForm');

  // Handle grape variety filtering
  function handleGrapeVarietyFilter() {
    const grapeVarietyCheckboxes = document.querySelectorAll('.grape-variety-checkbox');
    const filterValueCheckboxes = document.querySelectorAll('.grape-variety-filter-value');
    const appliedFiltersContainer = document.getElementById('grape-variety-applied-filters');

    // Render the applied filters for grape varieties based on checked checkboxes
    function renderAppliedFilters() {
      if (!appliedFiltersContainer) return;

      appliedFiltersContainer.style.display = 'contents';

      const filterParam = appliedFiltersContainer.dataset.filterParam;
      const selectedVarieties = Array.from(grapeVarietyCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.dataset.variety);

      // Clear existing applied filters
      appliedFiltersContainer.innerHTML = '';

      // Create applied filter tags for each selected variety
      selectedVarieties.forEach(variety => {
        const tag = document.createElement('a');
        tag.href = '#';
        tag.className = 'tag border border-black rounded-full py-1 px-3 text-sm grape-variety-remove';
        tag.dataset.variety = variety;
        tag.dataset.filterParam = filterParam;
        tag.innerHTML = `${variety} <i class="fa-light fa-xmark ms-1"></i>`;

        // Add click handler for remove
        tag.addEventListener('click', function(e) {
          e.preventDefault();
          const varietyCheckbox = Array.from(grapeVarietyCheckboxes).find(cb => cb.dataset.variety === variety);
          if (varietyCheckbox) {
            varietyCheckbox.checked = false;
            syncHiddenCheckboxes();
            renderAppliedFilters();
            addSelectedVarietiesToForm();
            filterForm.submit();
          }
        });

        appliedFiltersContainer.appendChild(tag);
      });
    }

    // Sync hidden checkboxes based on visible checkbox states
    function syncHiddenCheckboxes() {
      const selectedVarieties = Array.from(grapeVarietyCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.dataset.variety);

      // Clear all filter value checkboxes first
      filterValueCheckboxes.forEach(cb => cb.checked = false);

      // If no varieties are selected, don't check any hidden checkboxes
      if (selectedVarieties.length === 0) return;

      // Check filter value checkboxes that contain ANY of the selected varieties
      filterValueCheckboxes.forEach(filterValueCheckbox => {
        const valueLabel = filterValueCheckbox.dataset.valueLabel;
        if (valueLabel) {
          const checkboxVarieties = valueLabel.split(',').map(v => v.trim());
          const hasAnySelectedVariety = selectedVarieties.some(selected => 
            checkboxVarieties.includes(selected)
          );
          if (hasAnySelectedVariety) {
            filterValueCheckbox.checked = true;
          }
        }
      });
    }

    // Initialize checkbox states on page load - only check varieties that are truly selected
    function initializeCheckboxStates() {
      // Get URL parameters to find which grape varieties are actually selected
      const urlParams = new URLSearchParams(window.location.search);

      // Check for our custom parameter that stores the user's actual selection
      const selectedVarietiesParam = urlParams.get('grape_varieties');

      if (selectedVarietiesParam) {
        // User has explicitly selected varieties - use those
        const selectedVarieties = selectedVarietiesParam.split(',').map(v => v.trim());
        grapeVarietyCheckboxes.forEach(cb => {
          cb.checked = selectedVarieties.includes(cb.dataset.variety);
        });
      } else {
        // Fallback: check if there are any grape variety filter params
        const grapeVarietyParams = urlParams.getAll('filter.p.m.product.grape_variety');

        if (grapeVarietyParams.length === 0) {
          // No grape variety filter active, uncheck all
          grapeVarietyCheckboxes.forEach(cb => cb.checked = false);
        } else {
          // Legacy behavior: check all varieties that appear in filter params
          // This handles bookmarked URLs without the custom parameter
          const allVarietiesInFilters = new Set();
          grapeVarietyParams.forEach(param => {
            const varieties = param.split(',').map(v => v.trim());
            varieties.forEach(v => allVarietiesInFilters.add(v));
          });
          grapeVarietyCheckboxes.forEach(cb => {
            cb.checked = allVarietiesInFilters.has(cb.dataset.variety);
          });
        }
      }
    }

    // Add custom parameter to form before submission to track selected varieties
    function addSelectedVarietiesToForm() {
      const selectedVarieties = Array.from(grapeVarietyCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.dataset.variety);

      const existingInput = filterForm.querySelector('input[name="grape_varieties"]');
      if (existingInput) existingInput.remove();

      // Add new hidden input with selected varieties
      if (selectedVarieties.length > 0) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'grape_varieties';
        hiddenInput.value = selectedVarieties.join(',');
        filterForm.appendChild(hiddenInput);
      }
    }

    function addSelectedVarietiesToFormOnPageLoad() {
        // Get URL parameters to find which grape varieties are actually selected
        const urlParams = new URLSearchParams(window.location.search);

        // Check for our custom parameter that stores the user's actual selection
        const selectedVarietiesParam = urlParams.get('grape_varieties');

        // Add new hidden input with selected varieties
        if (selectedVarietiesParam) {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'grape_varieties';
            hiddenInput.value = selectedVarietiesParam;
            filterForm.appendChild(hiddenInput);
        }
    }

    // Initialize on page load
    initializeCheckboxStates();
    renderAppliedFilters();
    addSelectedVarietiesToFormOnPageLoad(); // Keep the hidden field in sync on page load

    // Handle checkbox changes
    grapeVarietyCheckboxes.forEach(varietyCheckbox => {
      varietyCheckbox.addEventListener('change', function() {
        syncHiddenCheckboxes();
        renderAppliedFilters();
        addSelectedVarietiesToForm();

        // Submit form on desktop, keep checked state on mobile
        if (document.body.clientWidth >= 993) {
          filterForm.submit();
        }
      });
    });
  }

  // Initialize grape variety filtering
  handleGrapeVarietyFilter();

  // Handle standard filter checkboxes (excluding grape variety checkboxes)
  document.querySelectorAll('input.filter-checkbox:not(.grape-variety-checkbox)').forEach(it => {
    it.addEventListener('change', evt =>{
      if(document.body.clientWidth < 993)return;
      filterForm.submit();
    })
  })

  // Intercept clicks on non-grape-variety filter remove links to preserve grape_varieties param
  document.querySelectorAll('#products-top .tag:not(.grape-variety-remove)').forEach(link => {
    link.addEventListener('click', function(e) {
      const grapeVarietiesInput = filterForm.querySelector('input[name="grape_varieties"]');
      if (grapeVarietiesInput && grapeVarietiesInput.value) {
        e.preventDefault();
        const url = new URL(this.href, window.location.origin);
        url.searchParams.set('grape_varieties', grapeVarietiesInput.value);
        window.location.href = url.toString();
      }
      // If no grape_varieties, let the default link behavior happen
    });
  });
});
